<script setup>
import { computed } from 'vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import MediaList from '../UI/Media/MediaList.vue'
import MediaListItem from '../UI/Media/MediaListItem.vue'
import useContractStats from '../../Composables/useContractStats'

const props = defineProps({
  contractStats: {
    type: Object,
    required: true,
  },
  showDashboardWallet: {
    type: Boolean,
    default: false,
  },
  showBuyout: {
    type: Boolean,
    default: false,
  },
  isWallet: {
    type: Boolean,
    default: false,
  },
})

const { getContractLink } = useContractStats()

const getLinkForStatus = computed(() => {
  return (status) => getContractLink(status, props.isWallet)
})
</script>

<template>
  <BlockContent
    icon="fa fa-file-pdf"
    title-t="home.dashboardContract.title"
    title-level="5"
    color="danger"
    e2e-block="homeDashboardContract"
  >
    <MediaList>
      <MediaListItem
        v-if="'SIGNING' in contractStats"
        :href="getLinkForStatus('SIGNING')"
        class-badge="badge-secondary"
        :text-badge="contractStats.SIGNING.count"
        :amount-badge="contractStats.SIGNING.amount"
        e2e-row="homedDashboardContractSigning"
      >
        {{ $t('home.dashboardContract.status.signing') }}
      </MediaListItem>
      <MediaListItem
        v-if="'DELIVERING' in contractStats"
        :href="getLinkForStatus('DELIVERING')"
        class-badge="badge-secondary"
        :text-badge="contractStats.DELIVERING.count"
        :amount-badge="contractStats.DELIVERING.amount"
        e2e-row="homedDashboardContractDelivering"
      >
        {{ $t('home.dashboardContract.status.delivering') }}
      </MediaListItem>
      <MediaListItem
        v-if="'PAYING' in contractStats"
        :href="getLinkForStatus('PAYING')"
        class-badge="badge-secondary"
        :text-badge="contractStats.PAYING.count"
        :amount-badge="contractStats.PAYING.amount"
        e2e-row="homedDashboardContractPaying"
      >
        {{ $t('home.dashboardContract.status.paying') }}
      </MediaListItem>
      <MediaListItem
        v-if="'PAID' in contractStats && showDashboardWallet"
        :href="getLinkForStatus('PAID')"
        class-badge="badge-secondary"
        :text-badge="contractStats.PAID.count"
        :amount-badge="contractStats.PAID.amount"
        e2e-row="homedDashboardContractPaid"
      >
        {{ $t('home.dashboardContract.status.paid') }}
      </MediaListItem>
      <MediaListItem
        v-if="'FINISH' in contractStats && showDashboardWallet"
        :href="getLinkForStatus('FINISH')"
        class-badge="badge-secondary"
        :text-badge="contractStats.FINISH.count"
        :amount-badge="contractStats.FINISH.amount"
        e2e-row="homedDashboardContractFinish"
      >
        {{ $t('home.dashboardContract.status.finish') }}
      </MediaListItem>
      <MediaListItem
        v-if="'CLOSED' in contractStats && showDashboardWallet"
        :href="getLinkForStatus('CLOSED')"
        class-badge="badge-secondary"
        :text-badge="contractStats.CLOSED.count"
        :amount-badge="contractStats.CLOSED.amount"
        e2e-row="homedDashboardContractCLOSED"
      >
        {{ $t('home.dashboardContract.status.closed') }}
      </MediaListItem>
      <MediaListItem
        v-if="'BUYOUT' in contractStats && showBuyout"
        :href="getLinkForStatus('BUYOUT')"
        class-badge="badge-danger"
        :text-badge="contractStats.BUYOUT.count"
        :amount-badge="contractStats.BUYOUT.amount"
        e2e-row="homedDashboardContractBuyout"
      >
        {{ $t('home.dashboardContract.status.buyout') }}
      </MediaListItem>
    </MediaList>
  </BlockContent>
</template>
